import mitt from "mitt";

// Create a new emitter
const emitter = mitt();

// Export that emitter
export default emitter;
